import styled, { css } from 'styled-components';

export const HudButtonContainer = styled.button<{ $active?: boolean, $collapsed?: boolean, $isMobileMenu?: boolean }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  color: var(--fg-soft, rgba(16, 24, 40, 0.75));
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  gap: 15px;
  padding: 8px 12px;

  transition: background .3s ease-in-out, color .3s ease-in-out;

  &:hover {
    background: var(--neutral-container-soft, rgba(88, 93, 105, 0.05));
  }

  ${({$active}) =>
      $active
          ? css`background: var(--accent-container-soft, rgba(255, 79, 18, 0.05));
            color: var(--accent-default, rgba(255, 79, 18, 1)); &:hover{background: var(--accent-container-soft, rgba(88, 93, 105, 0.05))}`
          : css``
  }

  ${({$collapsed}) =>
      $collapsed
          ? css`@media screen and (min-width: 992px) {
            width: 40px;
            height: 40px;
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
          }`
          : css``
  }

  ${({$isMobileMenu}) =>
      $isMobileMenu
          ? css`
            flex-direction: column;
            align-items: center;
            gap: 2px;
            justify-content: center;
            width: 100%;

            font-size: 10px;
            line-height: 12px;
          `

          : css``
  }
`;
